// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponse,
  GenericApiResponseGradingStatsReport,
  GenericApiResponseMetricsResponse,
  GenericApiResponseStudentProgressReport,
  GenericApiResponseSubmissionReport,
  GetEnrollmentsReportReportsEnrollmentsGetParams,
  GetGradingStatsReportParams,
  GetMetricsParams,
  GetStudentProgressReportParams,
  GetSubmissionsReportParams,
  HTTPValidationError,
} from '../../models';

/**
 * Get student progress analytics with pace curve comparison
 * @summary Get Student Progress Report
 */
export const getStudentProgressReport = (
  moduleId: string,
  params?: GetStudentProgressReportParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStudentProgressReport>> => {
  return axios.get(`/reports/modules/${moduleId}/students/progress`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetStudentProgressReportQueryKey = (moduleId: string, params?: GetStudentProgressReportParams) => {
  return [`/reports/modules/${moduleId}/students/progress`, ...(params ? [params] : [])] as const;
};

export const getGetStudentProgressReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentProgressReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  params?: GetStudentProgressReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentProgressReportQueryKey(moduleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentProgressReport>>> = ({ signal }) =>
    getStudentProgressReport(moduleId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!moduleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentProgressReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStudentProgressReportQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentProgressReport>>>;
export type GetStudentProgressReportQueryError = AxiosError<void | HTTPValidationError>;

export function useGetStudentProgressReport<
  TData = Awaited<ReturnType<typeof getStudentProgressReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  params: undefined | GetStudentProgressReportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStudentProgressReport<
  TData = Awaited<ReturnType<typeof getStudentProgressReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  params?: GetStudentProgressReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStudentProgressReport<
  TData = Awaited<ReturnType<typeof getStudentProgressReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  params?: GetStudentProgressReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Student Progress Report
 */

export function useGetStudentProgressReport<
  TData = Awaited<ReturnType<typeof getStudentProgressReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  params?: GetStudentProgressReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudentProgressReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStudentProgressReportQueryOptions(moduleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all submissions with support for filtering and sorting.

Supports standardized filtering and sorting via query parameters:
- filter: Format 'fieldname:value1|value2,fieldname2:value'
  Example: ?filter=state:graded,grade:90 or ?filter=student:john
  Available fields: id, course, student, module, corrector, grade, state
- sort: Format 'fieldname' (asc) or 'fieldname-' (desc)
  Example: ?sort=grade- or ?sort=student
- submittedSince: ISO-8601 UTC cutoff on submissionDate (inclusive)
- gradedSince: ISO-8601 UTC cutoff on correctionDate (inclusive)
 * @summary Get Submissions Report
 */
export const getSubmissionsReport = (
  params?: GetSubmissionsReportParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSubmissionReport>> => {
  return axios.get(`/reports/submissions`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetSubmissionsReportQueryKey = (params?: GetSubmissionsReportParams) => {
  return [`/reports/submissions`, ...(params ? [params] : [])] as const;
};

export const getGetSubmissionsReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubmissionsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetSubmissionsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubmissionsReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubmissionsReport>>> = ({ signal }) =>
    getSubmissionsReport(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubmissionsReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubmissionsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSubmissionsReport>>>;
export type GetSubmissionsReportQueryError = AxiosError<void | HTTPValidationError>;

export function useGetSubmissionsReport<
  TData = Awaited<ReturnType<typeof getSubmissionsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetSubmissionsReportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubmissionsReport<
  TData = Awaited<ReturnType<typeof getSubmissionsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetSubmissionsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubmissionsReport<
  TData = Awaited<ReturnType<typeof getSubmissionsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetSubmissionsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Submissions Report
 */

export function useGetSubmissionsReport<
  TData = Awaited<ReturnType<typeof getSubmissionsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetSubmissionsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubmissionsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubmissionsReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get enrollments with their modules / leave out grades, so its a list of courses
 * @summary Get Enrollments Report
 */
export const getEnrollmentsReportReportsEnrollmentsGet = (
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.get(`/reports/enrollments`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetEnrollmentsReportReportsEnrollmentsGetQueryKey = (
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
) => {
  return [`/reports/enrollments`, ...(params ? [params] : [])] as const;
};

export const getGetEnrollmentsReportReportsEnrollmentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnrollmentsReportReportsEnrollmentsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>> = ({ signal }) =>
    getEnrollmentsReportReportsEnrollmentsGet(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEnrollmentsReportReportsEnrollmentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>
>;
export type GetEnrollmentsReportReportsEnrollmentsGetQueryError = AxiosError<void | HTTPValidationError>;

export function useGetEnrollmentsReportReportsEnrollmentsGet<
  TData = Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetEnrollmentsReportReportsEnrollmentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnrollmentsReportReportsEnrollmentsGet<
  TData = Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnrollmentsReportReportsEnrollmentsGet<
  TData = Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Enrollments Report
 */

export function useGetEnrollmentsReportReportsEnrollmentsGet<
  TData = Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEnrollmentsReportReportsEnrollmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnrollmentsReportReportsEnrollmentsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEnrollmentsReportReportsEnrollmentsGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all enrollments from courses and show grade data from submissions where available
 * @summary Get User Modules Report
 */
export const getUserModulesReportReportsUsersUserIdModulesGet = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSubmissionReport>> => {
  return axios.get(`/reports/users/${userId}/modules`, options);
};

export const getGetUserModulesReportReportsUsersUserIdModulesGetQueryKey = (userId: string) => {
  return [`/reports/users/${userId}/modules`] as const;
};

export const getGetUserModulesReportReportsUsersUserIdModulesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserModulesReportReportsUsersUserIdModulesGetQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>> = ({
    signal,
  }) => getUserModulesReportReportsUsersUserIdModulesGet(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserModulesReportReportsUsersUserIdModulesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>
>;
export type GetUserModulesReportReportsUsersUserIdModulesGetQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUserModulesReportReportsUsersUserIdModulesGet<
  TData = Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserModulesReportReportsUsersUserIdModulesGet<
  TData = Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserModulesReportReportsUsersUserIdModulesGet<
  TData = Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Modules Report
 */

export function useGetUserModulesReportReportsUsersUserIdModulesGet<
  TData = Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserModulesReportReportsUsersUserIdModulesGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserModulesReportReportsUsersUserIdModulesGetQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return aggregated grading counts per lecturer and calendar month.
 * @summary Get Grading Stats Report
 */
export const getGradingStatsReport = (
  params: GetGradingStatsReportParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseGradingStatsReport>> => {
  return axios.get(`/reports/grading-stats`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetGradingStatsReportQueryKey = (params: GetGradingStatsReportParams) => {
  return [`/reports/grading-stats`, ...(params ? [params] : [])] as const;
};

export const getGetGradingStatsReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getGradingStatsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetGradingStatsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGradingStatsReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGradingStatsReport>>> = ({ signal }) =>
    getGradingStatsReport(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGradingStatsReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGradingStatsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getGradingStatsReport>>>;
export type GetGradingStatsReportQueryError = AxiosError<void | HTTPValidationError>;

export function useGetGradingStatsReport<
  TData = Awaited<ReturnType<typeof getGradingStatsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetGradingStatsReportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGradingStatsReport<
  TData = Awaited<ReturnType<typeof getGradingStatsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetGradingStatsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGradingStatsReport<
  TData = Awaited<ReturnType<typeof getGradingStatsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetGradingStatsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Grading Stats Report
 */

export function useGetGradingStatsReport<
  TData = Awaited<ReturnType<typeof getGradingStatsReport>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetGradingStatsReportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGradingStatsReport>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGradingStatsReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return named analytics figures for admin dashboards.
 * @summary Get Metrics
 */
export const getMetrics = (
  params: GetMetricsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseMetricsResponse>> => {
  return axios.get(`/reports/metrics`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetMetricsQueryKey = (params: GetMetricsParams) => {
  return [`/reports/metrics`, ...(params ? [params] : [])] as const;
};

export const getGetMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMetrics>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetMetricsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMetricsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetrics>>> = ({ signal }) =>
    getMetrics(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getMetrics>>>;
export type GetMetricsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetMetrics<
  TData = Awaited<ReturnType<typeof getMetrics>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetMetricsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMetrics<
  TData = Awaited<ReturnType<typeof getMetrics>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetMetricsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMetrics<
  TData = Awaited<ReturnType<typeof getMetrics>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetMetricsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Metrics
 */

export function useGetMetrics<
  TData = Awaited<ReturnType<typeof getMetrics>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetMetricsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMetricsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
